import { colors } from '@material-ui/core';

import {
    mdiTruckCheck,
    mdiRunFast,
    mdiCashEdit,
    mdiFlagOutline,
    mdiFlag,
    mdiFlagCheckered,
    mdiCurrencyUsd,
    mdiCheckAll,
    mdiRun,
    mdiTagArrowDown,
    mdiQrcodeScan,
    mdiStore,
    mdiPrinter,
    mdiSack
} from '@mdi/js';
import { isCONRegion } from 'utils/misc';

export let MSG_SOCIAL_CUSTOMER_DEFAULT = 'MSG_SOCIAL_CUSTOMER_DEFAULT';
export let MSG_SOCIAL_ORGANIZATION_DEFAULT = 'MSG_SOCIAL_ORGANIZATION_DEFAULT';
export let MSG_SOCIAL_CUSTOMER_RECYCLED = 'MSG_SOCIAL_CUSTOMER_RECYCLED';
export let MSG_SOCIAL_CUSTOMER_DONATED = 'MSG_SOCIAL_CUSTOMER_DONATED';

export let AUDIT_INFRACTION_USER_STATES = ['Under Review', 'Suspension'];
export let AUDIT_INFRACTION_USER_STATE_UNDER_REVIEW = 'Under Review';
export let AUDIT_INFRACTION_USER_STATE_SUSPENSION = 'Suspension';
export let AUDIT_INFRACTION_USER_STATE_NONE = 'None';

export let AUDIT_MANUAL_ADDRESS_VERIFICATION_CONFIG = {
    ALWAYS: 'Always',
    REGISTRATION_ONLY: 'Registration Only'
};

export const MAX_NUM_OF_RECYCLING_BAGS = 99;
export const MAX_NUM_OF_RECYCLING_BAGS_STAFF = 999;
export const MIN_NUM_OF_RECYCLING_BAGS = 0;

//Please use timezones from configuration, only use these as a fallback
export const TIMEZONES = [
    'America/Edmonton',
    'America/Toronto',
    'America/Montreal',
    'America/Blanc-Sablon',
    'America/Vancouver',
    'America/Metlakatla',
    'America/Creston',
    'Australia/Brisbane',
    'Australia/Sydney',
    'Australia/Perth',
    'Australia/Melbourne'
];

// pickupTypes
export const RESIDENTIAL = 'Residential';
export const COMMERCIAL = 'Commercial';
export const CONDO = 'Condo';
export const BOTTLE_DRIVE = 'Bottle Drive';
export const EXPRESS = 'Express';
export const DROPANDGO = 'Drop&Go';
export const LABELS = 'Request Labels';
export const EXTERNAL_LINK = 'External Link';
export const WALK_IN = 'Walk-In';
export const DEPOT_SEARCH = 'Search';
export const INSTRUCTIONS = 'Instructions';
export const QR_SCAN = 'QR Scan';
export const ACCESS_DOOR = 'Access Door';
//export const COLLECTION_PROGRAM_TYPE = `(${isCONRegion() ? 'eCSP' : 'IC&I'}) Collection Program`; // Use dynamic name now
export const COLLECTION_PROGRAM = `Collection Program`;

export const BREAK_POLICIES = {
    ANYTIME: 'Anytime',
    PREDETERMINED: 'Predetermined'
};

// bulkTypes
export const DROPNGO = 'inhouse';
export const ADJUSTMENT = 'adjustment';
export const PICKUP = 'pickup';
export const WALKIN = 'walk-in';

// export const PAYLOAD_ISSUE_NON_CONFORMANT = 'Non-conformant';
// export const PAYLOAD_ISSUE_HAZARDOUS = 'Hazardous';
// export const PAYLOAD_ISSUE_GARBAGE = 'Garbage';
// export const PAYLOAD_ISSUE_OTHER = 'Other';

export const COMMODITY_COLORS = {
    beverage: colors.blue[400],
    clothing: colors.green[400],
    electronics: colors.amber[500],
    credit: colors.orange[500],
    penalty: colors.red[500],
    promotion: colors.deepOrange[500]
};

export const ZONES_COLORS = [
    colors.blue, // Monday
    colors.teal, // Tuesday
    colors.lime, // Wednesday
    colors.orange, // Thursday
    colors.pink, // Friday,
    colors.deepPurple, // Saturday
    colors.brown // Sunday
];

export const BULK_STATUS_ICONS = {
    uncounted: mdiFlagOutline,
    counted: mdiFlag,
    submitted: mdiFlagCheckered,
    redeemed: mdiCurrencyUsd,
    invoiced: mdiCheckAll
};

export const BULK_STATUS_COLORS = {
    overdue: '#D9A1A3',
    uncounted: colors.yellow[200],
    counted: colors.indigo[200],
    submitted: colors.green[400],
    redeemed: colors.grey[200],
    invoiced: colors.cyan[200]
};

export const BULK_CHIP_COLOURS = {
    pickupType: '#D3D3D3', // Light gray
    overdue: '#D9A1A3', // Light red/pink
    complaint: '#E8C09C', // Light orange/peach
    approval: '#A1BCD9', // Light blue
    duplicate: '#E8DCA0', // Light yellow
    apiError: '#E8DCA0', // Light yellow
    issues: '#BCA1D9', // Light purple,
    promo: '#A1D9B7',
    rogue: '#D9A1A1', // Light dusty red
    lostCredit: '#424242'
};

export const LABEL_ICONS = {
    printed: mdiPrinter,
    scanned: mdiTagArrowDown
};

export const BULK_TYPE_ICONS = {
    pickup: mdiTruckCheck,
    adjustment: mdiCashEdit,
    inhouse: mdiSack,
    'walk-in': mdiStore //process.env.REACT_APP_REGION_EXT === 'CON' ? mdiQrcodeScan : mdiStore
};

export const BULK_TYPE_COLORS = {
    pickup: colors.blue[400],
    inhouse: colors.green[400],
    adjustment: colors.amber[500]
};

export const LOGGED_COLLECTIONS = [
    'batches',
    'bulks',
    'charities',
    'collectors',
    'configs',
    'configuration',
    'defaultcharitytasks',
    'entries',
    'locations',
    'pickups',
    'promos',
    'rates',
    'ratingPlatforms',
    'redemptions',
    'referrals',
    'regions',
    'trips',
    'users',
    'zones'
];

export const maxFileSize = 5 * 1024 * 1024; //5MiB
export const maxFileSizeMB = 2;
export const maxCharityImageWidthAndHeight = 400;
export const maxImageWidthAndHeight = 1600;

export const DEFAULT_DRIVER_WAGE = 1800;
export const DEFAULT_DRIVER_COMMISSION = 2;
export const DEFAULT_TRUCK_KPL = 3.75;
export const DEFAULT_GAS_PRICE_STD = 60;
export const DEFAULT_GAS_PRICE_AUS = 148;

export const CONTACT_EMAIL_OPTIONS = ['Redemptions', 'Service', 'Orders'];

export const INVALID_REDEMPTION_EMAILS = ['@privaterelay.appleid.com'];
export const PRIVATE_RELAY_EMAILS = ['@privaterelay.appleid.com'];

export const TAX_TYPES = ['none', 'excluded', 'included'];

export const USER_PERMISSIONS = ['Driver', 'Clerk'];
export const DRIVER_PAYMENT_MODELS = ['Wage', 'Commission'];
export const SUPPORT_TASK_NOTIFICATION_FREQUENCIES = ['None', 'Daily', 'Weekly'];

//Please use timezones from configuration, only use these as a fallback
export const TIME_ZONES_STD = ['America/Edmonton', 'America/Toronto'];
export const TIME_ZONES_ABD = ['America/Edmonton'];
export const TIME_ZONES_EXP = ['America/Vancouver', 'America/Metlakatla', 'America/Creston'];
export const TIME_ZONES_MXD = ['America/Montreal', 'America/Toronto'];
export const TIME_ZONES_CON = ['America/Montreal', 'America/Toronto'];
export const TIME_ZONES_AUS = ['Australia/Brisbane', 'Australia/Sydney', 'Australia/Perth', 'Australia/Melbourne'];
export const DAYS_OF_THE_WEEK = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
export const DAYS_OF_THE_WEEK_FR = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];

//Please use timezones from configuration, only use these as a fallback
export const TIMEZONES_BY_ENV = {
    STD: TIME_ZONES_STD,
    ABD: TIME_ZONES_ABD,
    EXP: TIME_ZONES_EXP,
    MXD: TIME_ZONES_MXD,
    CON: TIME_ZONES_CON,
    AUS: TIME_ZONES_AUS
};

export const CLUSTERING_ALGORITHMS = ['CAPACITY_FIRST', 'EVEN_SPLIT', 'MIN_DRIVERS_EVEN_SPLIT']; //TODO: add ROUTE_FIRST

export const COMMODITY_COMPLETION_STRATEGIES = ['Manual', 'Auto', 'Split Units', 'Accept Units'];

export const AVAILABLE_FREQUENCIES = {
    7: [7 * 1, 7 * 2, 7 * 4, 7 * 10, 7 * 12],
    14: [14 * 1, 14 * 2, 14 * 4, 14 * 6],
    21: [21 * 1, 21 * 2, 21 * 3, 21 * 4],
    28: [28 * 1, 28 * 2, 28 * 3, 28 * 4],
    35: [35 * 1, 35 * 2, 35 * 3],
    42: [42 * 1, 42 * 2, 42 * 3],
    49: [49 * 1, 49 * 2, 49 * 3],
    56: [56 * 1, 56 * 2, 56 * 3],
    63: [63 * 1, 63 * 2, 63 * 3],
    70: [70 * 1, 70 * 2, 70 * 3],
    77: [77 * 1, 77 * 2, 77 * 3],
    84: [84 * 1, 84 * 2, 84 * 3]
};

export const IGNORE_PAYLOAD_SIZE_SKUS = ['beverage'];
export const DEFAULT_GST_RATE_STD = 0.05;

export const TIPPING_MODEL_INDIVIDUAL = 'Individual';
export const TIPPING_MODEL_POOL = 'Pool';

export const AVAILABLE_LANGS = {
    STD: ['en'],
    ABD: ['en'],
    AUS: ['en'],
    EXP: ['en'],
    MXD: ['fr', 'en'],
    CON: ['fr', 'en']
};

export const ACCOUNT_TYPE_SELECTIONS = {
    PERSONAL: 'PERSONAL',
    BUSINESS: 'BUSINESS',
    GROUP: 'GROUP',
    COLLECTION_PROGRAM: 'COLLECTION_PROGRAM'
};

export const ACCOUNT_STATES_SELECTION = {
    ACTIVE: 'Active',
    STALE: 'Stale',
    UNDER_REVIEW: 'Under Review',
    SUSPENDED: 'Suspended',
    CLOSED: 'Closed',
    BANNED: 'Banned',
    IN_ARREARS: 'In Arrears',
    DELETED: 'Deleted'
};

export const COMMISSION_TYPES = ['Counts', 'Commodity Amount'];

export const INFRACTION_TYPES = {
    AUDIT_TYPE_BAGCOUNT: 'AUDIT_TYPE_BAGCOUNT',
    AUDIT_TYPE_DRIVERCOMPLAINT: 'AUDIT_TYPE_DRIVERCOMPLAINT',
    AUDIT_TYPE_COUNTERCOMPLAINT: 'AUDIT_TYPE_COUNTERCOMPLAINT',
    AUDIT_TYPE_AVGCONTAINERCOUNT: 'AUDIT_TYPE_AVGCONTAINERCOUNT',
    AUDIT_TYPE_AMOUNTDIFFERENCE: 'AUDIT_TYPE_AMOUNTDIFFERENCE',
    AUDIT_TYPE_LOSTBAGS: 'AUDIT_TYPE_LOSTBAGS',
    AUDIT_TYPE_PRINTEDLABELS: 'AUDIT_TYPE_PRINTEDLABELS',
    AUDIT_TYPE_REDEMPTIONAMOUNT: 'AUDIT_TYPE_REDEMPTIONAMOUNT',
    AUDIT_TYPE_REDEMPTIONEMAIL: 'AUDIT_TYPE_REDEMPTIONEMAIL',
    AUDIT_TYPE_SAMEIPADDRESS: 'AUDIT_TYPE_SAMEIPADDRESS',
    AUDIT_TYPE_SAMEDEVICEID: 'AUDIT_TYPE_SAMEDEVICEID',
    AUDIT_TYPE_HAZARDOUS: 'AUDIT_TYPE_HAZARDOUS',
    AUDIT_TYPE_GARBAGE: 'AUDIT_TYPE_GARBAGE',
    AUDIT_TYPE_BULK_SUBMISSION_APPROVAL: 'AUDIT_TYPE_BULK_SUBMISSION_APPROVAL',
    AUDIT_TYPE_MANUAL_ADDRESS_VERIFICATION: 'AUDIT_TYPE_MANUAL_ADDRESS_VERIFICATION',
    AUDIT_TYPE_DRIVER_GPS_OVERRIDE_APPROVAL: 'AUDIT_TYPE_DRIVER_GPS_OVERRIDE_APPROVAL',
    AUDIT_TYPE_DECLARATION_VERIFICATION: 'AUDIT_TYPE_DECLARATION_VERIFICATION',
    AUDIT_TYPE_2FA_ERROR: 'AUDIT_TYPE_2FA_ERROR',
    AUDIT_TYPE_CRON_TASK_ERROR: 'AUDIT_TYPE_CRON_TASK_ERROR',
    AUDIT_TYPE_ACCOUNT_LOCKOUT: 'AUDIT_TYPE_ACCOUNT_LOCKOUT',
    AUDIT_TYPE_PAYMENT_API_ERROR: 'AUDIT_TYPE_PAYMENT_API_ERROR',
    AUDIT_TYPE_BAGTAG_SELECTION_ERROR: 'AUDIT_TYPE_BAGTAG_SELECTION_ERROR',
    AUDIT_TYPE_BULK_QUEUE_ERROR: 'AUDIT_TYPE_BULK_QUEUE_ERROR',
    AUDIT_TYPE_MISSING_COLLECTOR_ERROR: 'AUDIT_TYPE_MISSING_COLLECTOR_ERROR',
    AUDIT_TYPE_MISSING_SUPER_GROUP_ERROR: 'AUDIT_TYPE_MISSING_SUPER_GROUP_ERROR',
    AUDIT_TYPE_DEPOSIT_CONFIGURATION_ERROR: 'AUDIT_TYPE_DEPOSIT_CONFIGURATION_ERROR',
    AUDIT_TYPE_POTENTIAL_DUPLICATE: 'AUDIT_TYPE_POTENTIAL_DUPLICATE',
    AUDIT_TYPE_INVALID_CHARITY_ERROR: 'AUDIT_TYPE_INVALID_CHARITY_ERROR',
    AUDIT_TYPE_MISSING_TECHNOLOGY_ERROR: 'AUDIT_TYPE_MISSING_TECHNOLOGY_ERROR',
    AUDIT_TYPE_BULK_RATES_ERROR: 'AUDIT_TYPE_BULK_RATES_ERROR',
    AUDIT_TYPE_BULK_API_ERROR: 'AUDIT_TYPE_BULK_API_ERROR',
    AUDIT_TYPE_BULK_TIME_WINDOW_ERROR: 'AUDIT_TYPE_BULK_TIME_WINDOW_ERROR',
    AUDIT_TYPE_BULK_THRESHOLD_ERROR: 'AUDIT_TYPE_BULK_THRESHOLD_ERROR',
    AUDIT_TYPE_CUSTOMER_ACCOUNT_CLOSED: 'AUDIT_TYPE_CUSTOMER_ACCOUNT_CLOSED',
    AUDIT_TYPE_CUSTOMER_ACCOUNT_DELETED: 'AUDIT_TYPE_CUSTOMER_ACCOUNT_DELETED',
    AUDIT_TYPE_PICKUP_CANCELLED: 'AUDIT_TYPE_PICKUP_CANCELLED',
    AUDIT_TYPE_PICKUP_ABORTED: 'AUDIT_TYPE_PICKUP_ABORTED',
    AUDIT_TYPE_CUSTOMER_COMPLAINT: 'AUDIT_TYPE_CUSTOMER_COMPLAINT',
    AUDIT_TYPE_COUNTS_COMPLAINT: 'AUDIT_TYPE_COUNTS_COMPLAINT',
    AUDIT_TYPE_PICKUPS_COMPLAINT: 'AUDIT_TYPE_PICKUPS_COMPLAINT',
    AUDIT_TYPE_PAYMENTS_COMPLAINT: 'AUDIT_TYPE_PAYMENTS_COMPLAINT'
};

export const INFRACTION_CATEGORIES = {
    APPROVALS: 'APPROVALS',
    ERRORS: 'ERRORS',
    ATTRITION: 'ATTRITION',
    COMPLAINTS: 'COMPLAINTS',
    INFRACTIONS: 'INFRACTIONS'
};

export const DEFAULT_AUDIT_TYPE_COLORS = {
    // Infractions
    AUDIT_TYPE_BAGCOUNT: '#D32F2F',
    AUDIT_TYPE_DRIVERCOMPLAINT: '#FF6F00',
    AUDIT_TYPE_AMOUNTDIFFERENCE: '#AD1457',
    AUDIT_TYPE_PRINTEDLABELS: '#FF5722',
    AUDIT_TYPE_COUNTERCOMPLAINT: '#E91E63',
    AUDIT_TYPE_AVGCONTAINERCOUNT: '#FF9800',
    AUDIT_TYPE_REDEMPTIONAMOUNT: '#C62828',
    AUDIT_TYPE_REDEMPTIONEMAIL: '#FF7043',
    AUDIT_TYPE_SAMEIPADDRESS: '#880E4F',
    AUDIT_TYPE_SAMEDEVICEID: '#BF360C',
    AUDIT_TYPE_HAZARDOUS: '#B71C1C',
    AUDIT_TYPE_GARBAGE: '#F4511E',
    AUDIT_TYPE_LOSTBAGS: '#cc0e27ff',

    // Approvals
    AUDIT_TYPE_BULK_SUBMISSION_APPROVAL: '#1976D2',
    AUDIT_TYPE_MANUAL_ADDRESS_VERIFICATION: '#42A5F5',
    AUDIT_TYPE_DECLARATION_VERIFICATION: '#0D47A1',
    AUDIT_TYPE_PHOTO_ID_VERIFICATION: '#64B5F6',
    AUDIT_TYPE_DRIVER_GPS_OVERRIDE_APPROVAL: '#0e5691ff',

    // Errors
    AUDIT_TYPE_DEPOSIT_CONFIGURATION_ERROR: '#920f83ff',
    AUDIT_TYPE_MISSING_SUPER_GROUP_ERROR: '#380359ff',
    AUDIT_TYPE_MISSING_COLLECTOR_ERROR: '#6A1B9A',
    AUDIT_TYPE_POTENTIAL_DUPLICATE: '#F4511E',
    AUDIT_TYPE_MISSING_TECHNOLOGY_ERROR: '#AB47BC',
    AUDIT_TYPE_BULK_RATES_ERROR: '#4A148C',
    AUDIT_TYPE_BULK_API_ERROR: '#E91E63',
    AUDIT_TYPE_2FA_ERROR: '#8E24AA',
    AUDIT_TYPE_CRON_TASK_ERROR: '#BA68C8',
    AUDIT_TYPE_PAYMENT_API_ERROR: '#C2185B',
    AUDIT_TYPE_BAGTAG_SELECTION_ERROR: '#7B1FA2',
    AUDIT_TYPE_INVALID_CHARITY_ERROR: '#d1a8d8ff',
    AUDIT_TYPE_BULK_QUEUE_ERROR: '#89274eff',

    // Attrition
    AUDIT_TYPE_CUSTOMER_ACCOUNT_CLOSED: '#F57C00',
    AUDIT_TYPE_CUSTOMER_ACCOUNT_DELETED: '#E65100',
    AUDIT_TYPE_ACCOUNT_LOCKOUT: '#FFB300',
    AUDIT_TYPE_PICKUP_CANCELLED: '#FDD835',
    AUDIT_TYPE_PICKUP_ABORTED: '#6D4C41',

    // Complaints
    AUDIT_TYPE_CUSTOMER_COMPLAINT: '#00796B',
    AUDIT_TYPE_COUNTS_COMPLAINT: '#2E7D32',
    AUDIT_TYPE_PICKUPS_COMPLAINT: '#00ACC1',
    AUDIT_TYPE_PAYMENTS_COMPLAINT: '#00695C'
};

export const PICKUP_TIME_OF_DAY_PREFERENCES = [
    { text: 'morning', value: 'Morning', time: '(8AM - 12PM)' },
    { text: 'afternoon', value: 'Afternoon', time: '(12PM - 5PM)' },
    { text: 'anytime', value: 'None', time: '(8AM - 5PM)' }
];

export const FEE_APPLICATION_OPTIONS = [
    'Apply to balance', //Normal (deduct from running balance / deposits)
    'Invoice' //Don't deduct from balance, create separate invoice item in history and keep out of balance.
];

export const INVOICE_FREQUENCY_OPTIONS = ['On Pickup', '15th of Month', '30th of Month'];

export const DESTINATION_ROUTING_OPTIONS = ['Zone', 'Driver'];

export const REPORT_TYPES = {
    CUSTOMER: 'customer',
    DRIVER: 'driver'
};

// ABBREVIATION MUST BE AT THE SAME INDEX OF FULL NAME
export const AUS_STATES = ['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'];
export const AUS_STATES_FULL_NAME = [
    'Australian Capital Territory',
    'New South Wales',
    'Northern Territory',
    'Queensland',
    'South Australia',
    'Tasmania',
    'Victoria',
    'Western Australia'
];

// ABBREVIATION MUST BE AT THE SAME INDEX OF FULL NAME
export const CAN_PROVINCES = ['AB', 'BC', 'MB', 'NB', 'NL', 'NS', 'NT', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT'];
export const CAN_PROVINCES_FULL_NAME = [
    'Alberta',
    'British Columbia',
    'Manitoba',
    'New Brunswick',
    'Newfoundland and Labrador',
    'Nova Scotia',
    'Northwest Territories',
    'Nunavut',
    'Ontario',
    'Prince Edward Island',
    'Quebec',
    'Saskatchewan',
    'Yukon'
];

export const S3_FALLBACK_IMAGE = 'https://local-std-pickup-photos.s3-us-west-2.amazonaws.com/fallback_image.jpg';

export const SHARE_AND_FEEDBACK_TYPES = [
    { key: 'shareAndFeedback-shareScreen', value: 'Share Screen' },
    { key: 'shareAndFeedback-referralScreen', value: 'Referral Screen' },
    { key: 'shareAndFeedback-ratingScreen', value: 'Rating Screen' }
];

export const DROP_OFF_TYPES = [
    { value: 'App Only', icon: 'mobile_friendly', localizationName: 'appOnly' },
    { value: 'Kiosk', icon: 'store', localizationName: 'kiosk' },
    { value: 'Kiosk & Scanner', icon: 'add_business', localizationName: 'kioskAndScanner' },
    { value: 'Access Door', icon: 'fiber_pin', localizationName: 'accessDoor' },
    { value: 'Reverse Vending Machine', icon: 'qr_code_scanner', localizationName: 'reverseVendingMachine' },
    { value: 'POR', icon: 'computer', localizationName: 'por' }
];

export const NO_TECHNOLOGY = { value: 'No Technology', icon: 'label_off', localizationName: 'noTechnology' };

export const ROLES = [
    'Customer Service',
    'Customer Service Administrator',
    'Finance Administrator',
    'Marketing',
    'Manager',
    'IT Administrator',
    'Administrator',
    'Scheme Marketing',
    ...(isCONRegion() ? ['Logistics'] : []),
    ...(isCONRegion() ? ['Human Resources'] : [])
    // 'New Role'
];

export const NONCONFORMANTISSUE = 'NONCONFORMANTISSUE';
export const LOWVOLUMEISSUE = 'LOWVOLUMEISSUE';
export const NON_CONFORMANT_COMPLAINT_CODE = '4A';
export const LOW_VOLUME_COMPLAINT_CODE = '4B';

export const REGISTRATION_TABS = {
    PERSONAL: 0,
    CHARITY: 1,
    DEPOT: 2, //deprecated
    BOTTLE_DRIVE: 3,
    BUSINESS: 4,
    GROUP: 5,
    COLLECTION_PROGRAM: 6
};

export const EXPRESS_APP_BALANCE_SKUTYPE = 'Opening Balance';
export const EXPRESS_APP_PAST_TRANSACTION_SKUTYPE = 'Legacy';

export const DB_LOG_TYPES = {
    PICKUP: 'Pickup',
    ORDER: 'Order',
    USER: 'User',
    REDEMPTION: 'Redemption',
    CONFIGURATION: 'Configuration',
    COLLECTOR: 'Collector',
    ZONE: 'Zone'
};

export const PAYLOAD_ISSUE_HAZARDOUS_CODE = '1';
export const PAYLOAD_ISSUE_GARBAGE_CODE = '2';

//these are taken from table 1 here: https://developers.google.com/maps/documentation/places/web-service/supported_types#table1
export const TRACKED_GOOGLE_PLACE_TYPES = [
    'accounting',
    'airport',
    'amusement_park',
    'aquarium',
    'art_gallery',
    'atm',
    'bakery',
    'bank',
    'bar',
    'beauty_salon',
    'bicycle_store',
    'book_store',
    'bowling_alley',
    'bus_station',
    'cafe',
    'campground',
    'car_dealer',
    'car_rental',
    'car_repair',
    'car_wash',
    'casino',
    'cemetery',
    'church',
    'city_hall',
    'clothing_store',
    'convenience_store',
    'courthouse',
    'dentist',
    'department_store',
    'doctor',
    'drugstore',
    'electrician',
    'electronics_store',
    'embassy',
    'fire_station',
    'florist',
    'funeral_home',
    'furniture_store',
    'gas_station',
    'gym',
    'hair_care',
    'hardware_store',
    'hindu_temple',
    'home_goods_store',
    'hospital',
    'insurance_agency',
    'jewelry_store',
    'laundry',
    'lawyer',
    'library',
    'light_rail_station',
    'liquor_store',
    'local_government_office',
    'locksmith',
    'lodging',
    'meal_delivery',
    'meal_takeaway',
    'mosque',
    'movie_rental',
    'movie_theater',
    'moving_company',
    'museum',
    'night_club',
    'painter',
    'park',
    'parking',
    'pet_store',
    'pharmacy',
    'physiotherapist',
    'plumber',
    'police',
    'post_office',
    'primary_school',
    'real_estate_agency',
    'restaurant',
    'roofing_contractor',
    'rv_park',
    'school',
    'secondary_school',
    'shoe_store',
    'shopping_mall',
    'spa',
    'stadium',
    'storage',
    'store',
    'subway_station',
    'supermarket',
    'synagogue',
    'taxi_stand',
    'tourist_attraction',
    'train_station',
    'transit_station',
    'travel_agency',
    'university',
    'veterinary_care',
    'zoo',
    'other' // This is not from the table above
];
export const GOOGLE_PLACE_TYPE_LOCALIZATIONS = {
    accounting: { en: 'Accounting', fr: 'Comptabilité' },
    airport: { en: 'Airport', fr: 'Aéroport' },
    amusement_park: { en: 'Amusement Park', fr: "Parc d'attractions" },
    aquarium: { en: 'Aquarium', fr: 'Aquarium' },
    art_gallery: { en: 'Art Gallery', fr: "Galerie d'art" },
    atm: { en: 'Atm', fr: 'Distributeur automatique' },
    bakery: { en: 'Bakery', fr: 'Boulangerie' },
    bank: { en: 'Bank', fr: 'Banque' },
    bar: { en: 'Bar', fr: 'Bar' },
    beauty_salon: { en: 'Beauty Salon', fr: 'Salon de beauté' },
    bicycle_store: { en: 'Bicycle Store', fr: 'Magasin de vélos' },
    book_store: { en: 'Book Store', fr: 'Librairie' },
    bowling_alley: { en: 'Bowling Alley', fr: 'Salle de bowling' },
    bus_station: { en: 'Bus Station', fr: 'Gare routière' },
    cafe: { en: 'Cafe', fr: 'Café' },
    campground: { en: 'Campground', fr: 'Terrain de camping' },
    car_dealer: { en: 'Car Dealer', fr: 'Concessionnaire automobile' },
    car_rental: { en: 'Car Rental', fr: 'Location de voitures' },
    car_repair: { en: 'Car Repair', fr: 'Réparation automobile' },
    car_wash: { en: 'Car Wash', fr: 'Lave-auto' },
    casino: { en: 'Casino', fr: 'Casino' },
    cemetery: { en: 'Cemetery', fr: 'Cimetière' },
    church: { en: 'Church', fr: 'Église' },
    city_hall: { en: 'City Hall', fr: 'Hôtel de ville' },
    clothing_store: { en: 'Clothing Store', fr: 'Magasin de vêtements' },
    convenience_store: { en: 'Convenience Store', fr: 'Supérette' },
    courthouse: { en: 'Courthouse', fr: 'Palais de justice' },
    dentist: { en: 'Dentist', fr: 'Dentiste' },
    department_store: { en: 'Department Store', fr: 'Grand magasin' },
    doctor: { en: 'Doctor', fr: 'Médecin' },
    drugstore: { en: 'Drugstore', fr: 'Pharmacie' },
    electrician: { en: 'Electrician', fr: 'Électricien' },
    electronics_store: { en: 'Electronics Store', fr: "Magasin d'électronique" },
    embassy: { en: 'Embassy', fr: 'Ambassade' },
    fire_station: { en: 'Fire Station', fr: 'Caserne de pompiers' },
    florist: { en: 'Florist', fr: 'Fleuriste' },
    funeral_home: { en: 'Funeral Home', fr: 'Pompes funèbres' },
    furniture_store: { en: 'Furniture Store', fr: 'Magasin de meubles' },
    gas_station: { en: 'Gas Station', fr: 'Station-service' },
    gym: { en: 'Gym', fr: 'Salle de sport' },
    hair_care: { en: 'Hair Care', fr: 'Soin des cheveux' },
    hardware_store: { en: 'Hardware Store', fr: 'Quincaillerie' },
    hindu_temple: { en: 'Hindu Temple', fr: 'Temple hindou' },
    home_goods_store: { en: 'Home Goods Store', fr: "Magasin d'articles pour la maison" },
    hospital: { en: 'Hospital', fr: 'Hôpital' },
    insurance_agency: { en: 'Insurance Agency', fr: "Agence d'assurance" },
    jewelry_store: { en: 'Jewelry Store', fr: 'Bijouterie' },
    laundry: { en: 'Laundry', fr: 'Blanchisserie' },
    lawyer: { en: 'Lawyer', fr: 'Avocat' },
    library: { en: 'Library', fr: 'Bibliothèque' },
    light_rail_station: { en: 'Light Rail Station', fr: 'Station de tramway' },
    liquor_store: { en: 'Liquor Store', fr: 'Magasin de spiritueux' },
    local_government_office: { en: 'Local Government Office', fr: 'Bureau du gouvernement local' },
    locksmith: { en: 'Locksmith', fr: 'Serrurier' },
    lodging: { en: 'Lodging', fr: 'Hébergement' },
    meal_delivery: { en: 'Meal Delivery', fr: 'Livraison de repas' },
    meal_takeaway: { en: 'Meal Takeaway', fr: 'Plat à emporter' },
    mosque: { en: 'Mosque', fr: 'Mosquée' },
    movie_rental: { en: 'Movie Rental', fr: 'Location de films' },
    movie_theater: { en: 'Movie Theater', fr: 'Cinéma' },
    moving_company: { en: 'Moving Company', fr: 'Entreprise de déménagement' },
    museum: { en: 'Museum', fr: 'Musée' },
    night_club: { en: 'Night Club', fr: 'Boîte de nuit' },
    painter: { en: 'Painter', fr: 'Peintre' },
    park: { en: 'Park', fr: 'Parc' },
    parking: { en: 'Parking', fr: 'Parking' },
    pet_store: { en: 'Pet Store', fr: "Magasin d'animaux" },
    pharmacy: { en: 'Pharmacy', fr: 'Pharmacie' },
    physiotherapist: { en: 'Physiotherapist', fr: 'Physiothérapeute' },
    plumber: { en: 'Plumber', fr: 'Plombier' },
    police: { en: 'Police', fr: 'Police' },
    post_office: { en: 'Post Office', fr: 'Bureau de poste' },
    primary_school: { en: 'Primary School', fr: 'École primaire' },
    real_estate_agency: { en: 'Real Estate Agency', fr: 'Agence immobilière' },
    restaurant: { en: 'Restaurant', fr: 'Restaurant' },
    roofing_contractor: { en: 'Roofing Contractor', fr: 'Couvreur' },
    rv_park: { en: 'Rv Park', fr: 'Parc pour camping-cars' },
    school: { en: 'School', fr: 'École' },
    secondary_school: { en: 'Secondary School', fr: 'École secondaire' },
    shoe_store: { en: 'Shoe Store', fr: 'Magasin de chaussures' },
    shopping_mall: { en: 'Shopping Mall', fr: 'Centre commercial' },
    spa: { en: 'Spa', fr: 'Spa' },
    stadium: { en: 'Stadium', fr: 'Stade' },
    storage: { en: 'Storage', fr: 'Stockage' },
    store: { en: 'Store', fr: 'Magasin' },
    subway_station: { en: 'Subway Station', fr: 'Station de métro' },
    supermarket: { en: 'Supermarket', fr: 'Supermarché' },
    synagogue: { en: 'Synagogue', fr: 'Synagogue' },
    taxi_stand: { en: 'Taxi Stand', fr: 'Station de taxis' },
    tourist_attraction: { en: 'Tourist Attraction', fr: 'Attraction touristique' },
    train_station: { en: 'Train Station', fr: 'Gare' },
    transit_station: { en: 'Transit Station', fr: 'Station de transit' },
    travel_agency: { en: 'Travel Agency', fr: 'Agence de voyages' },
    university: { en: 'University', fr: 'Université' },
    veterinary_care: { en: 'Veterinary Care', fr: 'Soin vétérinaire' },
    zoo: { en: 'Zoo', fr: 'Zoo' },
    other: { en: 'Other', fr: 'Autre' }
};

export const API_PAYMENT_STATUS = {
    SENT: 'SENT',
    RECEIVED: 'RECEIVED',
    REJECTED: 'REJECTED',
    ACCEPTED: 'ACCEPTED'
};

export const API_PAYMENT_STATUS_CODES = {
    PENDING_STATUSES: ['ACSP', 'ACTC', 'ACSC'],
    REJECT_STATUSES: ['RJCT', 'CANC'],
    COMPLETE_STATUSES: ['ACCC']
};

export const AUS_STATE_TO_CODE = {
    'New South Wales': 'NSW',
    Victoria: 'VIC',
    Queensland: 'QLD',
    'Western Australia': 'WA',
    'Australian Capital Territory': 'ACT'
};

export const integrationPermissionDescriptions = {
    setKantechPasscode: 'Set Kantech Passcodes for Users',
    validateOverrideCode: 'Validate collector override code',
    porCreate: 'Create Order',
    porSubmit: 'Receive Counts',
    incomingLabels: 'Receive Labels',
    incomingRedemptions: 'Receive ETransfer Req.',
    incomingChequeRedemptions: 'Receive Cheque Req.',
    validateRedemptions: 'Validate Redemptions',
    voucherPayout: 'Voucher Payout',
    outgoingCounts: 'Send Counts',
    outgoingCountsIntegrity: 'Check Sent Counts Integrity',
    outgoingAccountStatus: 'Send Account Status',
    outgoingAccountDetails: 'Send Account Details',
    outgoingRedemptions: 'Send ETransfers',
    outgoingChequeRedemptions: 'Send Cheques',
    outgoingInventory: 'Send Inventory',
    outgoingImages: 'Send Images',
    outgoingDropLocations: 'Send Drop Locations',
    getPaymentOptions: 'Get Payment Options',
    sendPayment: 'Send Payment',
    getPaymentStatus: 'Get Payment Status',
    getAccessDoorCode: 'Get Access Door Code',
    sendRegistrationDetails: 'Send Customer Registration Details',
    // sendUpdateDetails: 'Send Customer Update Details',
    updateLegacyPassword: 'Update Customer Legacy password',
    verifyLoginDetails: 'Send/Verify Customer Login Details',
    validateId: 'Validate Incoming User ID',
    getUser: 'Return User Name/ID',
    getCollectors: 'Return Collectors',
    getRates: 'Return Rates',
    getSupergroups: 'Return Supergroups',
    getDropLocations: 'Return Drop Locations',
    getRegions: 'Return Regions with featured charities',
    getBagStatus: 'Return Bag Status',
    pollTOMRASessions: 'Poll TOMRA Sessions',
    scanQRCode: 'Scan QR Code',
    getLoyaltyProgramCustomerData: 'Allow Third party to retrieve customer loyalty program information',
    sendLoyaltyProgramRequest: 'Enable the loyalty program endpoint',
    bagtagsQuery: 'Query Bagtags',
    ordersQuery: 'Query Orders',
    customersQuery: 'Query Customers',
    clerkReportsQuery: 'Query Clerk Reports',
    countsQuery: 'Query Counting Sessions',
    supportEscalationsQuery: 'Query Support Escalations',
    uploadCsv: 'Upload Daily CSV Data',
    uploadBatchPayments: 'Upload Payment Batches',
    downloadBatchPaymentStatus: 'Download Batch Payment Status'
};

export const integrationHistoryFunctionalities = {
    porCreate: 'Create Order',
    porSubmit: 'Receive Counts',
    incomingLabels: 'Receive Labels',
    incomingRedemptions: 'Receive ETransfer Req.',
    incomingChequeRedemptions: 'Receive Cheque Req.',
    validateRedemptions: 'Validate Redemptions',
    voucherPayout: 'Voucher Payout',
    outgoingCounts: 'Send Counts',
    outgoingCountsIntegrity: 'Check Sent Counts Integrity',
    outgoingAccountStatus: 'Send Account Status',
    outgoingAccountDetails: 'Send Account Details',
    outgoingRedemptions: 'Send ETransfers',
    outgoingChequeRedemptions: 'Send Cheques',
    outgoingInventory: 'Send Inventory',
    outgoingImages: 'Send Images',
    outgoingDropLocations: 'Send Drop Locations',
    getPaymentOptions: 'Get Payment Options',
    sendPayment: 'Send Payment',
    getPaymentStatus: 'Get Payment Status',
    getAccessDoorCode: 'Get Access Door Code',
    sendRegistrationDetails: 'Send Customer Registration Details',
    // sendUpdateDetails: 'Send Customer Update Details',
    updateLegacyPassword: 'Update Customer Legacy password',
    verifyLoginDetails: 'Send/Verify Customer Login Details',
    validateId: 'Validate Incoming User ID',
    getUser: 'Return User Name/ID',
    getRates: 'Return Rates',
    getSupergroups: 'Return Supergroups',
    getCollectors: 'Return Collectors',
    getDropLocations: 'Return Drop Locations',
    getRegions: 'Return Regions with featured charities',
    getBagStatus: 'Return Bag Status',
    pollTOMRASessions: 'Poll TOMRA Sessions',
    scanQRCode: 'Scan QR Code',
    authorization: 'Authorization',
    sync: 'Sync',
    setKantechPasscode: 'Set Kantech Passcodes for Users',
    validateOverrideCode: 'Validate collector override code',
    getLoyaltyProgramCustomerData: 'Allow Third party to retrieve customer loyalty program information',
    sendLoyaltyProgramRequest: 'Enable the loyalty program endpoint',
    bagtagsQuery: 'Query Bagtags',
    ordersQuery: 'Query Orders',
    customersQuery: 'Query Customers',
    clerkReportsQuery: 'Query Clerk Reports',
    countsQuery: 'Query Counting Sessions',
    supportEscalationsQuery: 'Query Support Escalations',
    uploadCsv: 'Upload Daily CSV Data',
    uploadBatchPayments: 'Upload Payment Batches',
    downloadBatchPaymentStatus: 'Download Batch Payment Status'
};

export const ORDER_STATUSES = ['open', 'counted', 'submitted', 'invoiced', 'overdue'];

export const DUPLICATE_API_BAGTAG_SETTINGS = {
    ACCEPT_AND_ADD: 'Yes -> Add To Order',
    REJECT_AND_LOG: 'No -> Reject + Log Error',
    DISCARD: 'No -> Discard'
};
export const DUPLICATE_API_BAGTAG_SETTINGS_OPTIONS = [
    DUPLICATE_API_BAGTAG_SETTINGS.ACCEPT_AND_ADD,
    DUPLICATE_API_BAGTAG_SETTINGS.REJECT_AND_LOG,
    DUPLICATE_API_BAGTAG_SETTINGS.DISCARD
];

export const API_SUBMISSION_CLOSED_ORDER_SETTINGS = {
    CREATE_NEW_ORDER: 'Create New Order',
    ADD_TO_EXISTING: 'Add to Existing Order'
};

export const API_SUBMISSION_CLOSED_ORDER_SETTINGS_OPTIONS = [
    API_SUBMISSION_CLOSED_ORDER_SETTINGS.CREATE_NEW_ORDER,
    API_SUBMISSION_CLOSED_ORDER_SETTINGS.ADD_TO_EXISTING
];

export const API_SUBMISSION_DUPLICATE_REDEEMED_SETTINGS = {
    CREATE_NEW_ORDER: 'Create New Order',
    REJECT_AND_LOG: 'Reject + Log Error'
};

export const API_SUBMISSION_DUPLICATE_REDEEMED_SETTINGS_OPTIONS = [
    API_SUBMISSION_DUPLICATE_REDEEMED_SETTINGS.CREATE_NEW_ORDER,
    API_SUBMISSION_DUPLICATE_REDEEMED_SETTINGS.REJECT_AND_LOG
];

export const DUPLICATE_API_TIME_LIMITS = ['None', '24 hours', '48 hours', '1 week']; // IF CHANGED, ALSO CHECK BULKSERVICE FOR VALUES (JUST DO WIDE CHECK)

// export const DUPLICATE_API_BAGTAG_SETTINGS = ['Yes -> Add To Order', 'No -> Reject + Log Error', 'No -> Discard']; // IF CHANGED, ALSO CHECK BULKSERVICE FOR VALUES (JUST DO WIDE CHECK)
// export const API_ORDER_CLOSE_OUT_WHEN = ['Manually', 'On Submission', 'End Of Day'];
// export const API_ORDER_CLOSE_OUT_CRITERIA = ['Always', 'Bags Reached', 'Threshold Reached'];

export const RESPONSE_TYPES = {
    SELECTABLE: 'selectable',
    BINARY: 'binary',
    NUMBER_LINE: 'number_line'
};

export const FEEDBACK_TYPES = [
    { value: 'on-time', label: 'On Time' },
    { value: 'left-bags', label: 'Left Bags' },
    { value: 'professional', label: 'Professional' }
];
export const API_ORDER_CLOSE_OUT_CRITERIA = ['Always', 'Bags Reached', 'Threshold Reached', 'Never'];
export const API_RVM_ORDER_CLOSE_OUT_CRITERIA = ['Always', 'Never'];
// export const API_ORDER_SERIAL_NUMBER_HANDLING = ['Add Automatically', 'Reject'];
export const DAY_NUMBER_MAP = {
    0: 'Sunday',
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday'
};

export const DEFAULT_TOMRA_CONFIG = {
    allowedIPs: [],
    name: 'TOMRA',
    description: 'TOMRA integration',
    active: true,
    logoURL: 'https://www.tomra.com/-/media/project/tomra/shared/logo/logo-tomra.png',
    integrationURL: 'https://us.api.developer.tomra.cloud',
    accessAccounts: [],
    history: [],
    outgoingXAPIKey: '',
    outgoingAuthContentType: 'application/x-www-form-urlencoded',
    outgoingAuthType: 'Basic',
    outgoingAuthParams: 'grant_type=client_credentials&scope=tomra-apis/external',
    outgoingTokenRequired: true,
    outgoingUsername: '',
    outgoingPassword: '',
    tokenPath: 'https://us.auth.developer.tomra.cloud/oauth2/token',
    permissions: {
        setKantechPasscode: false,
        porCreate: false,
        porSubmit: true,
        incomingRedemptions: false,
        incomingChequeRedemptions: false,
        validateRedemptions: false,
        voucherPayout: false,
        incomingLabels: false,
        outgoingCounts: false,
        outgoingCountsIntegrity: false,
        outgoingAccountStatus: false,
        outgoingAccountDetails: false,
        outgoingRedemptions: false,
        outgoingChequeRedemptions: false,
        outgoingInventory: false,
        outgoingImages: false,
        sendRegistrationDetails: false,
        updateLegacyPassword: false,
        verifyLoginDetails: false,
        getAccessDoorCode: false,
        validateId: false,
        getUser: false,
        pollTOMRASessions: false,
        getDropLocations: false,
        getRegions: false,
        getBagStatus: false,
        outgoingDropLocations: false,
        getPaymentOptions: false,
        sendPayment: false,
        getPaymentStatus: false,
        scanQRCode: true
    },
    forceIPCheck: true,
    endpoints: {
        testEndpoint: '/webhooks',
        outgoingCounts: '',
        outgoingCountsIntegrity: '',
        pollTOMRASessions: '',
        outgoingRedemptions: '',
        outgoingAccountStatus: '',
        outgoingAccountDetails: '',
        outgoingChequeRedemptions: '',
        outgoingImages: '',
        outgoingDropLocations: '',
        sendRegistrationDetails: '',
        updateLegacyPassword: '',
        verifyLoginDetails: '',
        getAccessDoorCode: '',
        scanQRCode: '/consumer-identities/qr-scans',
        getPaymentOptions: '',
        sendPayment: '',
        getPaymentStatus: ''
    },
    adjustmentRate: 90010,
    // bounceInvalidBags: true,
    createPrintedLabelOnPORCreate: false,
    createScannedLabelOnPORCreate: false,
    incomingCountsFormat: 'TOMRA',
    lostBagSku: 9300,
    tomraWebhookSecret: '',
    audience: '',
    issuer: '',
    keyPath: '',
    paymentsData: {
        transitNumber: '',
        applicationCatalogueId: '',
        olbbId: '',
        clientId: '',
        financialId: '',
        accountNumber: '',
        expiryTime: 30,
        encryption: {
            refreshInterval: 30
        }
    },
    privateKeyFilePath: '',
    publicKeyRequired: false,
    qrTokenPrefix: 'TOMRARCID-',
    scope: '',
    integrationProtocol: 'https'
};

export const DEFAULT_KIOSK_CONFIG = {
    allowedIPs: [],
    name: 'Kiosk',
    description: 'Kiosk Integration',
    active: true,
    logoURL: '',
    integrationURL: '',
    accessAccounts: [],
    history: [],
    outgoingXAPIKey: '',
    outgoingAuthContentType: 'application/x-www-form-urlencoded',
    outgoingAuthType: 'Default',
    outgoingAuthParams: '',
    outgoingTokenRequired: true,
    outgoingUsername: '',
    outgoingPassword: '',
    tokenPath: '/api/login',
    permissions: {
        setKantechPasscode: false,
        porCreate: true,
        porSubmit: false,
        incomingRedemptions: false,
        incomingChequeRedemptions: false,
        validateRedemptions: false,
        voucherPayout: false,
        incomingLabels: false,
        outgoingCounts: false,
        outgoingCountsIntegrity: false,
        pollTOMRASessions: false,
        outgoingRedemptions: false,
        outgoingChequeRedemptions: false,
        outgoingInventory: false,
        outgoingAccountStatus: false,
        outgoingAccountDetails: false,
        outgoingImages: false,
        sendRegistrationDetails: false,
        updateLegacyPassword: false,
        verifyLoginDetails: false,
        getAccessDoorCode: false,
        validateId: false,
        getUser: true,
        getDropLocations: true,
        getRegions: true,
        getBagStatus: false,
        outgoingDropLocations: true,
        getPaymentOptions: false,
        sendPayment: false,
        getPaymentStatus: false,
        scanQRCode: true
    },
    forceIPCheck: false,
    endpoints: {
        testEndpoint: '/api/checkStatus',
        outgoingCounts: '',
        outgoingCountsIntegrity: '',
        pollTOMRASessions: '',
        outgoingRedemptions: '',
        outgoingAccountStatus: '',
        outgoingAccountDetails: '',
        outgoingChequeRedemptions: '',
        outgoingImages: '',
        outgoingDropLocations: '/api/kiosk/updateTechnology',
        sendRegistrationDetails: '',
        updateLegacyPassword: '',
        verifyLoginDetails: '',
        getAccessDoorCode: '',
        scanQRCode: '/api/kiosk/qrCodeLogin',
        getPaymentOptions: '',
        sendPayment: '',
        getPaymentStatus: ''
    },
    adjustmentRate: 90010,
    // bounceInvalidBags: false,
    createPrintedLabelOnPORCreate: true,
    createScannedLabelOnPORCreate: false,
    incomingCountsFormat: 'DEFAULT',
    lostBagSku: 9300,
    tomraWebhookSecret: '',
    userField: 'email',
    audience: '',
    issuer: '',
    keyPath: '',
    paymentsData: {
        transitNumber: '',
        applicationCatalogueId: '',
        olbbId: '',
        clientId: '',
        financialId: '',
        accountNumber: '',
        expiryTime: 30,
        encryption: {
            refreshInterval: 30
        }
    },
    privateKeyFilePath: '',
    publicKeyRequired: false,
    qrTokenPrefix: 'KIOSK-',
    scope: '',
    integrationProtocol: 'https',
    includeLangInQRScan: true
};

export const DEFAULT_MX_CONFIG = {
    allowedIPs: [],
    name: 'MDDS',
    description: 'MDDS',
    active: true,
    logoURL: 'https://www.machinexrecycling.com/wp-content/themes/machinex/assets/logo_machinex_consigne_bleu.svg',
    integrationURL: '',
    accessAccounts: [],
    history: [],
    outgoingXAPIKey: '',
    outgoingAuthContentType: 'application/x-www-form-urlencoded',
    outgoingAuthType: 'Default',
    incomingCountsFormat: 'TOMRA',
    lostBagSku: 9300,
    adjustmentRate: 90010,
    // bounceInvalidBags: true,
    outgoingAuthParams: '',
    outgoingTokenRequired: false,
    tomraWebhookSecret: '',
    outgoingUsername: '',
    outgoingPassword: '',
    tokenPath: '',
    permissions: {
        setKantechPasscode: false,
        porCreate: false,
        porSubmit: true,
        incomingRedemptions: false,
        incomingChequeRedemptions: false,
        validateRedemptions: false,
        voucherPayout: false,
        incomingLabels: false,
        outgoingCounts: false,
        outgoingCountsIntegrity: false,
        outgoingAccountStatus: false,
        outgoingAccountDetails: false,
        outgoingRedemptions: false,
        outgoingChequeRedemptions: false,
        outgoingInventory: false,
        outgoingImages: false,
        sendRegistrationDetails: false,
        updateLegacyPassword: false,
        verifyLoginDetails: false,
        getAccessDoorCode: false,
        validateId: false,
        getUser: false,
        pollTOMRASessions: false,
        getDropLocations: false,
        getRegions: false,
        getBagStatus: false,
        outgoingDropLocations: false,
        getPaymentOptions: false,
        sendPayment: false,
        getPaymentStatus: false,
        scanQRCode: true
    },
    forceIPCheck: true,
    qrTokenPrefix: 'MX-',
    endpoints: {
        testEndpoint: '',
        outgoingCounts: '',
        outgoingCountsIntegrity: '',
        pollTOMRASessions: '',
        outgoingRedemptions: '',
        outgoingAccountStatus: '',
        outgoingAccountDetails: '',
        outgoingChequeRedemptions: '',
        outgoingImages: '',
        outgoingDropLocations: '',
        sendRegistrationDetails: '',
        updateLegacyPassword: '',
        verifyLoginDetails: '',
        getAccessDoorCode: '',
        scanQRCode: '/api/v1/qr-scan',
        getPaymentOptions: '',
        sendPayment: '',
        getPaymentStatus: ''
    },
    audience: '',
    issuer: '',
    keyPath: '',
    paymentsData: {
        transitNumber: '',
        applicationCatalogueId: '',
        olbbId: '',
        clientId: '',
        financialId: '',
        accountNumber: '',
        expiryTime: 30,
        encryption: {
            refreshInterval: 30
        }
    },
    privateKeyFilePath: '',
    publicKeyRequired: false,
    scope: '',
    integrationProtocol: 'https'
};
export const DEFAULT_BMO_CONFIG = {
    paymentsData: {
        keyAlias: '',
        transitNumber: '',
        applicationCatalogueId: '',
        olbbId: '',
        clientId: '',
        financialId: '',
        accountNumber: '',
        expiryTime: 7,
        encryption: {
            refreshInterval: 30,
            iv: '',
            key: '',
            lastRefreshDate: {
                $date: '2025-10-25T19:04:49.834Z'
            }
        }
    },
    allowedIPs: [],
    name: 'BMO',
    description: 'BMO Payments API',
    active: true,
    logoURL: 'https://www.bmo.com/dist/images/logos/bmo-blue-on-transparent-en.svg',
    integrationURL: 'https://partner-api.bmo.com/ext-services/tpp-tpsptnr/interac-etransfer/payment-initiation',
    accessAccounts: [],
    history: [],
    outgoingXAPIKey: '',
    outgoingAuthContentType: 'application/x-www-form-urlencoded',
    outgoingAuthType: 'JWT Assertion',
    privateKeyFilePath: '',
    issuer: '',
    audience: 'www.bmofg.com',
    scope: 'vendor-sec-dev-resourceserver/bmo.tpp-tpsptnr.payment-initiation.read',
    incomingCountsFormat: 'DEFAULT',
    lostBagSku: 9300,
    adjustmentRate: 90010,
    // bounceInvalidBags: false,
    outgoingAuthParams: 'grant_type=urn:ietf:params:oauth:grant-type:jwt-bearer',
    outgoingTokenRequired: true,
    publicKeyRequired: true,
    tomraWebhookSecret: '',
    outgoingUsername: '',
    outgoingPassword: '',
    tokenPath: 'https://partner-api.bmo.com/ext-services/oauth2/token',
    keyPath: 'https://partner-api.bmo.com/ext-services/issued-device-administration/client-data-encryption-key/get',
    permissions: {
        setKantechPasscode: false,
        porCreate: false,
        porSubmit: false,
        incomingRedemptions: false,
        incomingChequeRedemptions: false,
        validateRedemptions: false,
        voucherPayout: false,
        incomingLabels: false,
        outgoingCounts: false,
        outgoingCountsIntegrity: false,
        outgoingAccountStatus: false,
        outgoingAccountDetails: false,
        outgoingRedemptions: false,
        outgoingChequeRedemptions: false,
        outgoingInventory: false,
        outgoingImages: false,
        sendRegistrationDetails: false,
        updateLegacyPassword: false,
        verifyLoginDetails: false,
        getAccessDoorCode: false,
        validateId: false,
        getUser: false,
        pollTOMRASessions: false,
        getDropLocations: false,
        getRegions: false,
        getBagStatus: false,
        outgoingDropLocations: false,
        getPaymentOptions: true,
        sendPayment: true,
        getPaymentStatus: true,
        scanQRCode: false,
        getLoyaltyProgramCustomerData: false,
        sendLoyaltyProgramRequest: false
    },
    forceIPCheck: true,
    qrTokenPrefix: '',
    endpoints: {
        testEndpoint: '',
        outgoingCounts: '',
        outgoingCountsIntegrity: '',
        pollTOMRASessions: '',
        outgoingRedemptions: '',
        outgoingAccountStatus: '',
        outgoingAccountDetails: '',
        outgoingChequeRedemptions: '',
        outgoingImages: '',
        outgoingDropLocations: '',
        sendRegistrationDetails: '',
        updateLegacyPassword: '',
        verifyLoginDetails: '',
        getAccessDoorCode: '',
        scanQRCode: '',
        getPaymentOptions: '/get-emt-recipient-payment-options/get',
        sendPayment: '/customer-credit-transfer-initiation',
        getPaymentStatus: '/get-transaction',
        sendLoyaltyProgramRequest: ''
    },
    keyData: {
        provider: 'BMO',
        keyId: '',
        key: '',
        keyAlgorithm: '',
        expiresOn: {
            $date: '2025-12-12T01:07:06.986Z'
        }
    },
    outgoingXVendorCP: '',
    integrationProtocol: 'https'
};
export const DEFAULT_SOLINK_CONFIG = {
    name: 'Solink',
    description: 'Solink Integration',
    active: true,
    history: [],
    logoURL: '',
    integrationProtocol: 'sftp',
    integrationURL: '',
    accessAccounts: [],
    outgoingUsername: '',
    outgoingPassword: '',
    outgoingTokenRequired: false,
    publicKeyRequired: false,
    outgoingXAPIKey: '',
    outgoingXVendorCP: '',
    outgoingAuthType: 'Default',
    privateKeyFilePath: '',
    issuer: '',
    audience: '',
    scope: '',
    outgoingAuthContentType: 'application/x-www-form-urlencoded',
    outgoingAuthParams: '',
    incomingCountsFormat: 'DEFAULT',
    lostBagSku: 9300,
    adjustmentRate: 90010,
    uploadCsvCollectors: [],
    // bounceInvalidBags: false,
    tomraWebhookSecret: '',
    tokenPath: '',
    keyPath: '',
    allowedIPs: [],
    qrTokenPrefix: '',
    includeLangInQRScan: false,
    permissions: {
        porCreate: false,
        porSubmit: false,
        incomingLabels: false,
        incomingRedemptions: false,
        incomingChequeRedemptions: false,
        validateRedemptions: false,
        voucherPayout: false,
        setKantechPasscode: false,
        outgoingCounts: false,
        outgoingCountsIntegrity: false,
        outgoingRedemptions: false,
        outgoingChequeRedemptions: false,
        outgoingInventory: false,
        outgoingImages: false,
        outgoingAccountStatus: false,
        outgoingAccountDetails: false,
        outgoingDropLocations: false,
        sendRegistrationDetails: false,
        updateLegacyPassword: false,
        verifyLoginDetails: false,
        getAccessDoorCode: false,
        validateId: false,
        getUser: false,
        getDropLocations: false,
        getRegions: false,
        getBagStatus: false,
        pollTOMRASessions: false,
        scanQRCode: false,
        getPaymentOptions: false,
        sendPayment: false,
        getPaymentStatus: false,
        getLoyaltyProgramCustomerData: false,
        sendLoyaltyProgramRequest: false,
        bagtagsQuery: false,
        ordersQuery: false,
        customersQuery: false,
        clerkReportsQuery: false,
        countsQuery: false,
        supportEscalationsQuery: false,
        uploadCsv: true
    },
    endpoints: {
        testEndpoint: '',
        outgoingCounts: '',
        outgoingCountsIntegrity: '',
        outgoingImages: '',
        outgoingRedemptions: '',
        outgoingChequeRedemptions: '',
        outgoingAccountStatus: '',
        outgoingAccountDetails: '',
        outgoingDropLocations: '',
        sendRegistrationDetails: '',
        updateLegacyPassword: '',
        verifyLoginDetails: '',
        getAccessDoorCode: '',
        pollTOMRASessions: '',
        scanQRCode: '',
        getPaymentOptions: '',
        sendPayment: '',
        getPaymentStatus: '',
        sendLoyaltyProgramRequest: ''
    },
    paymentsData: {
        keyAlias: '',
        transitNumber: '',
        applicationCatalogueId: '',
        olbbId: '',
        clientId: '',
        financialId: '',
        accountNumber: '',
        expiryTime: 30,
        encryption: {
            refreshInterval: 30
        }
    },
    forceIPCheck: true
};

export const DEFAULT_DATA_ACCESS_CONFIG = {
    name: 'API Access',
    description: 'Data Access',
    active: true,
    history: [],
    logoURL: '',
    integrationProtocol: 'https',
    integrationURL: '',
    accessAccounts: [],
    outgoingUsername: '',
    outgoingPassword: '',
    outgoingTokenRequired: false,
    publicKeyRequired: false,
    outgoingXAPIKey: '',
    outgoingXVendorCP: '',
    outgoingAuthType: 'Default',
    privateKeyFilePath: '',
    issuer: '',
    audience: '',
    scope: '',
    outgoingAuthContentType: 'application/x-www-form-urlencoded',
    outgoingAuthParams: '',
    incomingCountsFormat: 'DEFAULT',
    lostBagSku: 9300,
    adjustmentRate: 90010,
    uploadCsvCollectors: [],
    // bounceInvalidBags: false,
    tomraWebhookSecret: '',
    tokenPath: '',
    keyPath: '',
    allowedIPs: [],
    qrTokenPrefix: '',
    includeLangInQRScan: false,
    permissions: {
        porCreate: false,
        porSubmit: false,
        incomingLabels: false,
        incomingRedemptions: false,
        incomingChequeRedemptions: false,
        setKantechPasscode: false,
        outgoingCounts: false,
        outgoingCountsIntegrity: false,
        outgoingRedemptions: false,
        outgoingChequeRedemptions: false,
        outgoingInventory: false,
        outgoingImages: false,
        outgoingAccountStatus: false,
        outgoingAccountDetails: false,
        outgoingDropLocations: false,
        sendRegistrationDetails: false,
        updateLegacyPassword: false,
        verifyLoginDetails: false,
        getAccessDoorCode: false,
        validateId: false,
        getUser: false,
        getDropLocations: false,
        getRegions: false,
        getBagStatus: false,
        pollTOMRASessions: false,
        scanQRCode: false,
        getPaymentOptions: false,
        sendPayment: false,
        getPaymentStatus: false,
        getLoyaltyProgramCustomerData: false,
        sendLoyaltyProgramRequest: false,
        bagtagsQuery: true,
        ordersQuery: true,
        customersQuery: true,
        clerkReportsQuery: true,
        countsQuery: false,
        supportEscalationsQuery: false,
        uploadCsv: false
    },
    endpoints: {
        testEndpoint: '',
        outgoingCounts: '',
        outgoingCountsIntegrity: '',
        outgoingImages: '',
        outgoingRedemptions: '',
        outgoingChequeRedemptions: '',
        outgoingAccountStatus: '',
        outgoingAccountDetails: '',
        outgoingDropLocations: '',
        sendRegistrationDetails: '',
        updateLegacyPassword: '',
        verifyLoginDetails: '',
        getAccessDoorCode: '',
        pollTOMRASessions: '',
        scanQRCode: '',
        getPaymentOptions: '',
        sendPayment: '',
        getPaymentStatus: '',
        sendLoyaltyProgramRequest: ''
    },
    paymentsData: {
        keyAlias: '',
        transitNumber: '',
        applicationCatalogueId: '',
        olbbId: '',
        clientId: '',
        financialId: '',
        accountNumber: '',
        expiryTime: 30,
        encryption: {
            refreshInterval: 30
        }
    },
    forceIPCheck: false
};

export const DEFAULT_IRIS_CONFIG = {
    name: 'IRIS',
    description: 'Sync data from IRIS',
    active: true,
    history: [],
    logoURL: '',
    allowedIPs: [],
    integrationURL: '',
    type: 'GATEWAY',
    accessAccounts: [],
    endpoints: {
        testEndpoint: '',
        outgoingCounts: '',
        outgoingCountsIntegrity: '',
        pollTOMRASessions: '',
        outgoingRedemptions: '',
        outgoingAccountStatus: '',
        outgoingAccountDetails: '',
        outgoingChequeRedemptions: '',
        outgoingImages: '',
        outgoingDropLocations: '',
        sendRegistrationDetails: '',
        updateLegacyPassword: '',
        verifyLoginDetails: '',
        getAccessDoorCode: '',
        scanQRCode: '',
        sendLoyaltyProgramRequest: ''
    },
    outgoingPassword: '',
    outgoingTokenRequired: true,
    outgoingUsername: '',
    permissions: {
        setKantechPasscode: true,
        porCreate: true,
        porSubmit: true,
        incomingRedemptions: true,
        incomingChequeRedemptions: true,
        incomingLabels: true,
        outgoingCounts: true,
        outgoingCountsIntegrity: true,
        outgoingAccountStatus: true,
        outgoingAccountDetails: true,
        outgoingRedemptions: true,
        outgoingChequeRedemptions: true,
        outgoingInventory: true,
        outgoingImages: false,
        sendRegistrationDetails: true,
        updateLegacyPassword: true,
        verifyLoginDetails: true,
        getAccessDoorCode: true,
        validateId: true,
        getUser: true,
        pollTOMRASessions: false,
        getDropLocations: false,
        getRegions: false,
        getBagStatus: true,
        outgoingDropLocations: false,
        scanQRCode: false,
        getLoyaltyProgramCustomerData: true,
        sendLoyaltyProgramRequest: true
    },
    tokenPath: '/Token',
    forceIPCheck: false,
    outgoingAuthContentType: 'application/x-www-form-urlencoded',
    outgoingAuthParams: 'grant_type=password',
    outgoingAuthType: 'Default',
    outgoingXAPIKey: '',
    incomingCountsFormat: 'EXPRESS',
    adjustmentRate: 9300,
    // bounceInvalidBags: true,
    createPrintedLabelOnPORCreate: false,
    createScannedLabelOnPORCreate: true,
    lostBagSku: 9300,
    tomraWebhookSecret: '',
    addBagtagListToOrder: true,
    qrTokenPrefix: '',
    allowHardSync: true,
    integrationProtocol: 'https'
};

export const DEFAULT_CBA_CONFIG = {
    name: 'CBA',
    description: 'CBA Batch Payments Integration',
    active: true,
    history: [],
    logoURL: 'https://www.commbank.com.au/content/dam/commbank/commBank-logo.svg',
    integrationProtocol: 'sftp',
    integrationURL: 'sftp://<accountNumber>@securetransfer.commbank.com.au',
    accessAccounts: [],
    requireIncomingToken: true,
    incomingTokenAuthMethod: 'POST Body (email/password)',
    useHMACValidationOnPorSubmit: false,
    outgoingUsername: '',
    outgoingPassword: '',
    outgoingTokenRequired: false,
    publicKeyRequired: false,
    outgoingXAPIKey: '',
    outgoingXVendorCP: '',
    outgoingAuthType: 'Default',
    privateKeyFilePath: '/etc/CBA/id_rsa_LT3_ACT_CBA',
    issuer: '',
    audience: '',
    scope: '',
    outgoingAuthContentType: 'application/x-www-form-urlencoded',
    outgoingAuthParams: '',
    incomingCountsFormat: 'DEFAULT',
    lostBagSku: 9300,
    adjustmentRate: 90010,
    uploadCsvCollectors: [],
    tomraWebhookSecret: '',
    tokenPath: '',
    keyPath: '',
    useIPRouting: false,
    allowedIPs: [],
    qrTokenPrefix: '',
    includeLangInQRScan: false,
    permissions: {
        porCreate: false,
        porSubmit: false,
        incomingLabels: false,
        incomingRedemptions: false,
        incomingChequeRedemptions: false,
        validateRedemptions: false,
        setKantechPasscode: false,
        validateOverrideCode: false,
        outgoingCounts: false,
        outgoingCountsIntegrity: false,
        outgoingRedemptions: false,
        outgoingChequeRedemptions: false,
        outgoingInventory: false,
        outgoingImages: false,
        outgoingAccountStatus: false,
        outgoingAccountDetails: false,
        outgoingDropLocations: false,
        sendRegistrationDetails: false,
        updateLegacyPassword: false,
        verifyLoginDetails: false,
        getAccessDoorCode: false,
        validateId: false,
        getCollectors: false,
        getRates: false,
        getSupergroups: false,
        getUser: false,
        getDropLocations: false,
        getRegions: false,
        getBagStatus: false,
        pollTOMRASessions: false,
        scanQRCode: false,
        getPaymentOptions: false,
        sendPayment: false,
        getPaymentStatus: false,
        getLoyaltyProgramCustomerData: false,
        sendLoyaltyProgramRequest: false,
        bagtagsQuery: false,
        ordersQuery: false,
        customersQuery: false,
        clerkReportsQuery: false,
        supportEscalationsQuery: false,
        uploadCsv: false,
        downloadBatchPaymentStatus: true,
        uploadBatchPayments: true
    },
    endpoints: {
        testEndpoint: '',
        outgoingCounts: '',
        outgoingCountsIntegrity: '',
        outgoingImages: '',
        outgoingRedemptions: '',
        outgoingChequeRedemptions: '',
        outgoingAccountStatus: '',
        outgoingAccountDetails: '',
        outgoingDropLocations: '',
        sendRegistrationDetails: '',
        updateLegacyPassword: '',
        verifyLoginDetails: '',
        getAccessDoorCode: '',
        pollTOMRASessions: '',
        scanQRCode: '',
        getPaymentOptions: '',
        sendPayment: '',
        getPaymentStatus: '',
        sendLoyaltyProgramRequest: ''
    },
    paymentsData: {
        keyAlias: '',
        transitNumber: '',
        applicationCatalogueId: '',
        olbbId: '',
        clientId: '',
        financialId: '',
        accountNumber: '',
        expiryTime: 30,
        encryption: {
            refreshInterval: 30
        }
    },
    forceIPCheck: true,
    tags: [],
    sftpAuthType: 'Key Pair',
    downloadBatchPaymentStatusLocalFolder: 'incomingBatchStatusFiles',
    downloadBatchPaymentStatusRemoteFolder: 'CommBiz/inbox',
    uploadBatchPaymentLocalFolder: 'outgoingBatchPaymentFiles',
    uploadBatchPaymentRemoteFolder: 'CommBiz/inbox'
};

export const DRIVER_REMINDER_STYLES = {
    DIALOG: 'Dialog',
    CALCULATION: 'Calculation'
};

export const BULK_CHANNELS = [
    'KIOSK_API',
    'MACHINE_BULK',
    'MACHINE_RVM',
    'DRIVER_COMPLETE',
    'POR_EMBEDDED',
    'POR_STANDALONE',
    // 'RVM_WORKAROUND',
    'CUSTOMER_DROP'
];

export const BULK_ORDER_SUBTYPES = [
    'EXP_BAGS',
    'EXP_LABELS',
    'ROGUE',
    'POR',
    'RVM',
    'LOST_AND_FOUND',
    'BAG_REIMBURSEMENT',
    'CREDIT_ADJUSTMENT'
];

export const SHIPPING_CONTAINER_TYPES = ['commodity', 'sku'];
